import type { AgentNodeData } from '@saaga/shared/interfaces/agency-node.interface'
import { useEffect } from 'react'
import type { UseFormReturn } from 'react-hook-form'
import { type AgentNodeFormSchemaType, defaultAgentNodeFormValues } from './agency-node-form.schema'

export const useAgentNodeFormReset = (
  form: UseFormReturn<AgentNodeFormSchemaType>,
  nodeData: AgentNodeData | null,
  nodeId: string | null
): void => {
  useEffect(() => {
    if (!nodeData || !nodeId) {
      form.reset(defaultAgentNodeFormValues)
      return
    }
    form.reset({
      label: nodeData.label,
      roleDescription: nodeData.roleDescription ?? '',
      systemPrompt: nodeData.systemPrompt,
      model: nodeData.model,
      temperature: nodeData.temperature,
      toolList: nodeData.toolList,
      imageUrl: nodeData.imageUrl,
    })
  }, [nodeId, nodeData, form])
}
